import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=04c46c56&scoped=true"
import script from "./NumberField.vue?vue&type=script&lang=js"
export * from "./NumberField.vue?vue&type=script&lang=js"
import style0 from "./NumberField.vue?vue&type=style&index=0&id=04c46c56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c46c56",
  null
  
)

export default component.exports